<template>
    <form>
        <div class="row" v-if="hasData">
            <div class="col-md-5 col-12">
                <v-select v-model="form.category" :options="categories"
                          :placeholder="categoryPlaceholder">
                    <template #no-options="{ search, searching, loading }">
                        {{ noOptionSlot }} <br>

                        <a :href="`${searchPageUrl}?vneml_prod_${languageId}[query]=${search}`" class="cta-link d-inline-block mt-3 mb-2">{{ searchForPrefix }}
                            <strong>'{{ search }}'</strong></a>
                    </template>
                </v-select>
            </div>
            <div class="col-md-5 col-12">
                <v-select v-model="form.region" :options="regions" :placeholder="regionPlaceholder"></v-select>
            </div>
            <div class="col-md-2 d-flex justify-content-end">
                <button class="btn btn-primary" @click.prevent="handleClick">{{ searchButtonText }}</button>
            </div>
        </div>
    </form>
</template>

<script>
import vSelect from 'vue-select';

export default {
    name: "SearchBlock",

    props: {
        isHome: {
            type: Boolean,
            default: false
        },
        selectedCategoryId: {
            type: String,
        },
        selectedRegionId: {
            type: Number,
            default: 0
        },
        languageId: {
            type: String,
            default: 'nl'
        },
        searchPageUrl: {
            type: String
        }
    },

    components: {vSelect},

    data() {
        return {
            categoryPlaceholder: window.Drupal.t('Type or select a topic'),
            regionPlaceholder: window.Drupal.t('The whole region'),
            searchButtonText: window.Drupal.t('Explore'),
            noOptionSlot: window.Drupal.t('No matching option, click below to use our advanced search function'),
            searchForPrefix: window.Drupal.t('Search for'),
            form: {
                category: {
                    code: 0,
                    label: ''
                },
                region: {
                    code: 0,
                    label: ''
                },
            },
            categories: [],
            regions: []
        }
    },

    computed: {
        hasData() {
            return !_.isEmpty(this.categories) && !_.isEmpty(this.regions)
        },

        category() {
            if (!_.isEmpty(this.categories) && !_.isEmpty(this.categories.find(element => element.code == this.selectedCategoryId))) {
                return this.categories.find(element => element.code == this.selectedCategoryId);
            }

            return null;
        },

        region() {
            if (!_.isEmpty(this.regions) && !_.isEmpty(this.regions.find(element => element.code === this.selectedRegionId))) {
                return this.regions.find(element => element.code === this.selectedRegionId);
            }

            return {
                'code': 0,
                'label': this.regionPlaceholder
            }
        }
    },

    mounted() {
        this.loadData();
    },

    methods: {
        loadData() {
            axios.get(`/${this.languageId}/api/data`)
                .then(response => {
                    this.categories = response.data.categories;
                    this.regions = response.data.regions;
                })
                .finally(() => {
                    this.form.category = this.category;
                    this.form.region = this.region;

                    this.$emit('alive', {
                        form: this.form,
                        categories: this.categories,
                        regions: this.regions
                    });
                });
        },

        handleClick() {
            if (this.isHome && !_.isEmpty(this.form.category) && !_.isEmpty(this.form.region)) {
                window.location.href = `/${this.languageId}/zoeken/${this.form.category.code}/${this.form.region.code}`;
                return;
            } else if (this.isHome && !_.isEmpty(this.form.category)) {
                window.location.href = `/${this.languageId}/zoeken/${this.form.category.code}`;
                return;
            }

            this.$emit('input', this.form)
        }
    },
}
</script>

<style lang="scss" scoped>
.cta-link {
    color: #0018E2;
}
</style>
